import { atom } from "jotai";

export type UserFilterItem = {
	id: string | number;
	name: string;
};

export type UserFilterParamType = "ltlBrokers" | "laes" | "customers";

export type SharedUserFilterState = {
	paramType: UserFilterParamType;
	value: UserFilterItem[];
};

/**
 * Shared user-filter selection (LTL AR / LAE / Customer + selected items)
 * used by AR Dashboard, Loads (Shipment Board), and Quote Board so that
 * picking a filter on one page carries over to the others within the same
 * session.
 *
 * `null` means "not yet hydrated"; the first consumer seeds it with the
 * current employee under "ltlBrokers".
 */
export const sharedUserFilterAtom = atom<SharedUserFilterState | null>(null);
